__turbopack_context__.v({
  "bar": "burger-module-scss-module__JjzclG__bar",
  "bottomBar": "burger-module-scss-module__JjzclG__bottomBar",
  "centerBar": "burger-module-scss-module__JjzclG__centerBar",
  "circle": "burger-module-scss-module__JjzclG__circle",
  "inverted": "burger-module-scss-module__JjzclG__inverted",
  "neutral": "burger-module-scss-module__JjzclG__neutral",
  "open": "burger-module-scss-module__JjzclG__open",
  "topBar": "burger-module-scss-module__JjzclG__topBar",
  "wrapper": "burger-module-scss-module__JjzclG__wrapper",
});
